import React from 'react';

interface MenuItemProps {
  value?: string | number;
  disabled?: boolean;
  children?: React.ReactNode;
}

const MenuItem: React.FC<MenuItemProps> = ({ value, disabled = false, children }) => {
  return (
    <option value={value} disabled={disabled}>
      {children}
    </option>
  );
};

export default MenuItem;

